import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Constants } from 'src/app/models/constants';
import { BehaviorSubject, Observable, Subject, catchError, firstValueFrom, of, throwError } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ReportInput } from 'src/app/postlogin/inward-invoice-ro/inward-invoice-RO.component';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import * as saveAs from "file-saver";
import { EncryptDecryptService } from '../encrypt-decrypt.service';
@Injectable({
    providedIn: 'root',
})
export class SharedService {
        /**
   * Unicode-safe base64 encoding that handles characters outside Latin1 range (e.g., Polish, Arabic, etc.)
   * @param str - String to encode
   * @returns Base64 encoded string
   */
  public unicodeSafeBase64Encode(str: string): string {
    // Convert Unicode string to UTF-8 encoded URI component, then to base64
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    }));
  }
    private ksaDropdownChangeEmitter = new BehaviorSubject<any>('einvoice');
    private navBarItemsSubject = new BehaviorSubject<any[]>([]);
    private roleChangeEmitter = new Subject<any>();
    private message = new BehaviorSubject<any>(null);
    private ksaselectedoption: any;
    groupCode: any;
    displayRistrictedmsg: any;
    DisplayRistrictedmsg: any;
    private groupDisplayRistrictedmsgEmitter = new Subject<any>();
    roles: any;
    private rolesEmitter = new Subject<any>();
    private groupCodeChangeEmitter = new BehaviorSubject<string>('');
    private KsaPermissionsChangeEmitter = new BehaviorSubject<any>([]);
    userEmail: any;
    KsaPermissions: any;
    private subject = new Subject<any>();
    private entityChangeSubject = new Subject<string>();
    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: MsalService,
        private storageService: StorageService, private encryptDecryptService: EncryptDecryptService) {

    }

    setMessage(message: any) {
        this.message.next(message);
    }

    getMessage(): Observable<any> {
        return this.message.asObservable();
    }

    roleChange(val?) {
        this.roleChangeEmitter.next(val ? val : '');
    }
    roleChangeObserve() {
        return this.roleChangeEmitter.asObservable();
    }

    getNavBarItemsObservable() {
        return this.navBarItemsSubject.asObservable();
    }

    downloadFile(fileName, baseStorage, fileStore, blobStore, container, path): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/downloadFiles`;

        let params = new HttpParams();
        params = params.append('fileName', fileName);
        params = params.append('baseStorage', baseStorage);
        params = params.append('fileStore', fileStore);
        params = params.append('blobStore', blobStore);
        params = params.append('container', container);
        if (fileStore) {
            params = params.append('path', path);
        }

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    //TODO :: to be removed in future sprints
    downloadReport(fileId, type, path, fileName): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/downloadReport`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('type', type);
        params = params.append('path', path);
        params = params.append('fileName', fileName);
        //params=params.append('fileType',fileType);

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    //service implementation for download MoF error and success report

    downloadMofReport(fileId, type, path, fileName, orgFileName, source, mofInterface, transformation, extension): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadMofReport`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('type', type);
        params = params.append('path', path);
        params = params.append('fileName', fileName);
        params = params.append('orgFileName', orgFileName);
        params = params.append('source', source);
        params = params.append('mofInterface', mofInterface);
        params = params.append('dataTransformationType', transformation);
        params = params.append('extension', extension);


        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    downloadEYReport(fileId, type, path, fileName, orgFileName, source, mofInterface, transformation, fileStandard, extension) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadEYReport`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('type', type);
        params = params.append('path', path);
        params = params.append('fileName', fileName);
        params = params.append('orgFileName', orgFileName);
        params = params.append('source', source);
        params = params.append('mofInterface', mofInterface);
        params = params.append('dataTransformationType', transformation);
        params = params.append('fileStandard', fileStandard);
        params = params.append('extension', extension);

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });


    }

    downloadGVRTFile(fileId, gvrtStatus): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadGVRTFile`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('gvrtStatus', gvrtStatus);


        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    getParentEntities(): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/home/getUserDetails`;
        return this.http.get<any>(url);
    }


    emitEntityChange(value?: string) {
        if (value) {
            this.entityChangeSubject.next(value);
        }
    }

    entityChangeObserve() {
        return this.entityChangeSubject.asObservable();
    }

    setKsaOption(option) {
        this.ksaselectedoption = option;
    }

    emitKsaOptionChange() {
        this.ksaDropdownChangeEmitter.next(this.ksaselectedoption);
    }

    getksaOptionChangeObserve() {
        return this.ksaDropdownChangeEmitter.asObservable();
    }
    generateReport(inputReportData: Array<any>, requestUrl = "generateInvMgmtSyncReport"): Observable<any> {

        const jsonString = JSON.stringify(inputReportData)

        const url = `${Constants.REPORT_BASE_API_URL}/${requestUrl}`;

        let params = new HttpParams();
        params = params.append('responseId', this.unicodeSafeBase64Encode(jsonString.toString()));
        return this.http.post(url, params, { responseType: 'blob', observe: 'response' })

    }

    generateXMLReport(responseId: string[], requestURL = "generateInvMgmtXmlReport"): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/${requestURL}`;

        let params = new HttpParams();
        params = params.append('responseId', btoa(responseId.join("<~@~@>")));
        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
        
    }

    downloadGeneratedReport(requestId, category): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadGeneratedReport`;

        let params = new HttpParams();
        params = params.append('requestId', requestId);
        params = params.append('category', category);

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    getReportParamDetails(requestId: string): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/getReportParamDetails`;
        let reqs = new HttpParams();

        reqs = reqs.append('requestId', requestId);

        return this.http.post<any>(url, reqs);
    }

    getUTCOffset(country: string) {
        switch (country) {
            case 'PL':
                return 120;
            case 'GMT':
                return 0;
        }
    }

    fetchEntityDetails(entityId): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/home/fetchEntityDetails`;
        let params = new HttpParams();

        params = params.append('entityId', entityId);
        return this.http.post<any>(url, params);
    }

    downloadSyncReports(date, taxId, mofInterface, userId, reportType, recordStatus, extension): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadSyncReports`;

        let params = new HttpParams();
        params = params.append('date', date);
        params = params.append('taxId', taxId);
        params = params.append('mofInterface', mofInterface);
        params = params.append('userId', userId);
        params = params.append('reportType', reportType);
        params = params.append('recordStatus', recordStatus);
        params = params.append('extension', extension);

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    downloadUPOReport(sessionRefNum: string[],entityId: string): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadInvMgmtUpoReport`;

        let params = new HttpParams();
        params = params.append('sessionRefNum', sessionRefNum.toString());
        params = params.append('entityId', entityId);


        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    downloadGeneratedReportForm(downloadFrom) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadGeneratedReport`;

        this.submitDownloadForm(url, downloadFrom);
    }

    downloadMofReportForm(downloadFrom) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadMofReport`;

        this.submitDownloadForm(url, downloadFrom);
    }


    public downloadPDFReportForm(downloadFrom: FormGroup): void {
        const url = `${Constants.PDF_BASE_API_URL}/pdfInvoiceGenerator`;
        this.submitEncodedDownloadForm(url, downloadFrom);
    }

    downloadEYReportForm(downloadFrom) {
        let url;
        if (this.storageService.getWithDefaultPassphrase('Country') == 'MY' && this.router.url?.includes('taxIDvalidator')) {
            url = `${Constants.REPORT_BASE_API_URL}/downloadTinValidatorReport`;
        } else {
            url = `${Constants.REPORT_BASE_API_URL}/downloadEYReport`;
        }

        this.submitDownloadForm(url, downloadFrom);
    }

    downloadPDFReportForm1(data: FormGroup): Observable<HttpResponse<Blob>> {
        const url = `${Constants.PDF_BASE_API_URL}/pdfInvoiceGenerator`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

        const body = this.encodeDownloadForm(data.value);

        return this.http.post(url, body, { headers, responseType: 'blob', observe: 'response' }).pipe(
            catchError(error => {
                console.error('Error downloading PDF', error);
                return of(new HttpResponse<Blob>({ body: new Blob([]), status: 500 }));
            })
        );
    }
    downloadPDFReportAsync(data: FormGroup): Observable<HttpResponse<Blob>> {
        const url = `${Constants.PDF_BASE_API_URL}/triggerPDFReport`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

        const body = this.encodeDownloadForm(data.value);

        return this.http.post(url, body, { headers, responseType: 'blob', observe: 'response' }).pipe(
            catchError(error => {
                console.error('Error downloading PDF', error);
                return of(new HttpResponse<Blob>({ body: new Blob([]), status: 500 }));
            })
        );
    }
    
    fetchPDFCustomisationDetails(entityId: string, screenName: string): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/fetchPDFCustomisationDetails`;
        let params = new HttpParams();
        params = params.append('entityId', entityId);
        params = params.append('screenName', screenName);  // first letter of screenName should be capital
        return this.http.post(url, params);
    }

    downloadMofXmlReportForm(data: FormGroup): Observable<HttpResponse<Blob>> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadMofZipReport`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

        const body = this.DownloadForm(data.value);

        return this.http.post(url, body, { headers, responseType: 'blob', observe: 'response' }).pipe(
            catchError(error => {
                console.error('Error downloading PDF', error);
                return of(new HttpResponse<Blob>({ body: new Blob([]), status: 500 }));
            })
        );
    }

    downloadMofXmlReportFormSovosXML(data: FormGroup, entityId?: string): Observable<HttpResponse<Blob>> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadSovosXMl`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const formValue = entityId ? { ...data.value, entityId } : data.value;

         const body = this.DownloadForm(formValue);

        return this.http.post(url, body, { headers, responseType: 'blob', observe: 'response' }).pipe(
            catchError(error => {
                console.error('Error downloading PDF', error);
                return of(new HttpResponse<Blob>({ body: new Blob([]), status: 500 }));
            })
        );
    }

    downloadInwardXmlReportForm1(data: FormGroup, reportTypeUrl = "downloadInwardXmlData"): Observable<HttpResponse<Blob>> {
        const url = `${Constants.REPORT_BASE_API_URL}/${reportTypeUrl}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        const body = this.encodeDownloadForm(data.value);
        return this.http.post(url, body, { headers, responseType: 'blob', observe: 'response' });
    }

    downloadFiles(response, defaultFileName?, defaultExtension?) {
        if (response.body.size <= 22) {
            return throwError(() => new Error('Unable to download files due to a technical issue. Please contact the help desk.'));
        } else {
            const contentDisposition = response.headers.get('Content-Disposition');
            const contentType = response.headers.get('Content-Type') || `application/${defaultExtension}`;
            let fileName = defaultFileName ? defaultFileName.replaceAll(/[/\\:*?"<>|]/g, '') : defaultFileName;

            if (contentDisposition && !defaultFileName) {
                const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = fileNameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, '');
                }
            }

            if (!fileName.includes('.')) {
                fileName += `.${defaultExtension}`;
            }
            if (contentType.includes('zip')) {
                this.saveToFileSystem(response, `${contentType};charset=UTF-8`, fileName);
            } else {
                this.saveToFileSystem(response, contentType, fileName);
            }
            return new Observable<void>(observer => {
                observer.next();
                observer.complete();
            });
        }
    }

    saveToFileSystem(response, type, fileName) {
        const blob = new Blob([response.body], { type });
        saveAs(blob, fileName);
    }

    private encodeDownloadForm(data: any): string {
        const formBody: string[] = [];
        for (const [key, value] of Object.entries(data)) {
            const encodedKey = encodeURIComponent(key);
            //const encodedValue = encodeURIComponent(btoa(value?.toString()));
            const encodedValue = btoa(unescape(encodeURIComponent(value?.toString())));
            let urlSafeEncodedStr = encodedValue.replace(/\+/g, '%2B');
            formBody.push(`${encodedKey}=${urlSafeEncodedStr}`);
        }
        return formBody.join('&');
    }
    private DownloadForm(data: any): string {
        const formBody: string[] = [];
        for (const [key, value] of Object.entries(data)) {
            const encodedKey = encodeURIComponent(key);
            const encodedValue = encodeURIComponent(value?.toString());
            formBody.push(`${encodedKey}=${encodedValue}`);
        }
        return formBody.join('&');
    }

    submitDownloadForm(url, downloadFrom) {
        const form: HTMLFormElement = document.createElement('form');
        form.style.display = 'none';
        form.method = 'POST';
        form.action = url;
        form.target = "_blank";
        let input;

        for (const [key, value] of Object.entries(downloadFrom.value)) {
            input = document.createElement('input');
            input.name = key;
            input.id = key;
            input.value = value;
            form.appendChild(input);
        }

        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
    }

    submitEncodedDownloadForm(url, downloadFrom) {
        const form: HTMLFormElement = document.createElement('form');
        form.style.display = 'none';
        form.method = 'POST';
        form.action = url;
        form.target = "_blank";
        let input;

        for (const [key, value] of Object.entries(downloadFrom.value)) {
            input = document.createElement('input');
            input.name = key;
            input.id = key;
            //input.value = btoa(value?.toString());
            //input.value = btoa(unescape(encodeURIComponent(value?.toString())))
            let encodedValue = btoa(unescape(encodeURIComponent(value?.toString())))
            input.value = encodedValue.replace(/\+/g, '%2B');
            form.appendChild(input);
        }

        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
    }


    checkTransformationFile(fileId, type, path, fileName, fileStatus) {
        const url = `${Constants.REPORT_BASE_API_URL}/checkTransformationFile`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('type', type);
        params = params.append('path', path);
        params = params.append('fileName', fileName);
        params = params.append('fileStatus', fileStatus);

        return this.http.post(url, params);
    }

    fetchXmlData(enums: string[]): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/fetchGetXmlData`;

        let params = new HttpParams();
        params = params.append('enums', enums.toString());

        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    downloadMofZipReportForm(downloadFrom) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadMofZipReport`;
        this.submitDownloadForm(url, downloadFrom);
    }

    downloadEyXmlReportForm(downloadFrom) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadEyXmlReport`;

        this.submitDownloadForm(url, downloadFrom);
    }

    downloadInwardXmlReportForm(downloadFrom) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadInwardXmlData`;

        this.submitEncodedDownloadForm(url, downloadFrom);
    }

    downloadSDIXmlReport(entity: string, docNum: string, SDIIdentifier: string, sdiStatus: string, type: string, criteria: string, fromDate: string, toDate: string,
        invoiceType: string, recordStatus: string) {
        const url = `${Constants.APP_BASE_API_URL}/getXmlFromSDI`;

        let params = new HttpParams();
        params = params.append('Entity', entity);
        params = params.append('DocNum', docNum);
        params = params.append('SDIIdentifier', SDIIdentifier);
        params = params.append('SDIStatus', sdiStatus);
        params = params.append('Type', type);
        params = params.append('criteria', criteria);
        params = params.append('fromDate', fromDate);
        params = params.append('toDate', toDate);
        params = params.append('invoiceType', invoiceType);
        params = params.append('recordStatus', recordStatus);

        return this.http.post<any>(url, params);
    }

    private responseSubject = new Subject<string>();
    get response$(): Observable<string> {

        return this.responseSubject.asObservable();
    }

    handleFileUploaded(infoResponse: string) {

        this.responseSubject.next(infoResponse);
    }

    submitLifecycleStatus(payload, screenType): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/` + (screenType?.toUpperCase() === 'OUT' ? 'submitLifeCycleStatusOutward' : 'submitLifeCycleStatusInward');
        let params = new HttpParams();
        Object.keys(payload).forEach(key => {
            params = params.append(key, payload[key]);
        });
        return this.http.post<any>(url, params);
    }

  public getFRLifecycleOutwardHistory(reqParams): Observable<any> {
      const url = `${Constants.APP_BASE_API_URL}/getFR-lifeCycleOutward`;
      let reqs = new HttpParams();
      reqs = reqs.append('uIds', reqParams.uIds || '')
      reqs = reqs.append('direction', reqParams.direction || '')
        return this.http.post<any>(url, reqs);
    }

    downloadLifeCycleOutwardXml(reqParams): Observable<any> {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadLifeCycleOutwardXml`;
        let params = new HttpParams();
         params = params.append('lifeCycleId', reqParams.lifeCycleId || '')
       params = params.append('direction', reqParams.direction || '')
        return this.http.post(url, params, { responseType: 'blob', observe: 'response' });
    }

    public downloadReportForm(downloadFrom: FormGroup): void {
        const url = `${Constants.REPORT_BASE_API_URL}/generateInwardSyncReport`;
        this.submitDownloadForm(url, downloadFrom);
    }

    initiateSelectedInvoiceReport(responseIdList: Array<ReportInput>): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/initiateSelectedInvoiceReport`;
        //let reqs = new HttpParams();
        let params = new HttpParams();
        params = params.append('responseIdList', btoa(unescape(encodeURIComponent(JSON.stringify(responseIdList)))));
        return this.http.post<any>(url, params);
    }

    initiateInwardGenerateV2(payload) {
        const url = `${Constants.APP_BASE_API_URL}/initiateInwardGenerateReport`;
        let reqs = new HttpParams();
        reqs = reqs.appendAll(payload);
        return this.http.post<any>(url, reqs);
    }

    // creating generic function to initiate report without row selection.
    initiateWithoutRowSelection(payload, requestUrl) {
        const url = `${Constants.APP_BASE_API_URL}/${requestUrl}`;
        let reqs = new HttpParams();
        reqs = reqs.appendAll(payload);
        return this.http.post<any>(url, reqs);
    }

    initiateInwardGenerateReport(criteria: string, fromDate: any, toDate: any, selectedEntity: string, reportCode: string, invoiceTypeCode: string, userId: string,subject?,fromDateAndTime?,toDateAndTime?): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/initiateInwardGenerateReport`;
        let reqs = new HttpParams();
        reqs = reqs.append('selectedCriteria', criteria)
        reqs = reqs.append('fromDataReceivedDate', fromDate)
        reqs = reqs.append('toDataReceivedDate', toDate)
        reqs = reqs.append('selectedEntity', selectedEntity)
        reqs = reqs.append('reportCode', reportCode)
        reqs = reqs.append('selectedInvType', invoiceTypeCode)
        reqs = reqs.append('selectedUserId', userId);
        if (subject) {
            reqs = reqs.append('subject', subject);
        }
        if (fromDateAndTime) {
            reqs = reqs.append('fromDateAndTime', fromDateAndTime);
        }
        if (toDateAndTime) {
            reqs = reqs.append('toDateAndTime', toDateAndTime);
        }

        return this.http.post<any>(url, reqs);
    }

    downloadAttachmentReport(downloadFrom) {
        const url = `${Constants.REPORT_BASE_API_URL}/downloadAttachments`;

        this.submitDownloadForm(url, downloadFrom);
    }

    getAllGroupCodes() {
        this.userEmail =
            this.authService?.instance?.getActiveAccount()?.username.toLowerCase().length > 0
                ? this.authService?.instance?.getActiveAccount()?.username.toLowerCase()
                : this.storageService.deCodeJWT('preferred_username');
        const httpOptions = {
            headers: new HttpHeaders({
                'Username': this.userEmail
            })
        };
        let url = `${Constants.KSA_APP_BASE_API_URL}/getUserGroupCode.do`;
        return this.http.post<any>(url, null, httpOptions);
    }

    setDisplayRistrictedmsg(displayRistrictedmsg) {
        this.displayRistrictedmsg = displayRistrictedmsg;
    }

    emitDisplayRistrictedmsgChange() {
        this.groupDisplayRistrictedmsgEmitter.next(this.displayRistrictedmsg);
    }

    DisplayRistrictedmsgChangeObserve() {
        return this.groupDisplayRistrictedmsgEmitter.asObservable();
    }

    setRoles(roles) {
        this.roles = roles;
    }

    emitRolesChange() {
        this.rolesEmitter.next(this.roles);
    }

    DisplayRolesChangeObserve() {
        return this.rolesEmitter.asObservable();
    }

    setGroupCOde(groupCode) {
        this.groupCode = groupCode;
    }

    emitgroupCodeChange() {
        this.groupCodeChangeEmitter.next(this.groupCode);
    }

    groupCodeChangeObserve() {
        return this.groupCodeChangeEmitter.asObservable();
    }

    checkRecordsDumpedForPopup(fileId, type, isEyReport) {
        const url = `${Constants.REPORT_BASE_API_URL}/checkRecordsDumped`;

        let params = new HttpParams();
        params = params.append('fileId', fileId);
        params = params.append('type', type);
        params = params.append('isEyReport', isEyReport);

        return this.http.post(url, params);
    }

    getActiveDowntimeWindow() {
        const url = `${Constants.APP_BASE_API_URL}/getActiveDowntimeWindow?requestType=DOWNTIME_WINDOW`;
        return this.http.get<any>(url);
    }

    getUserRoles(userId): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/home/getUserRoles`;
        let params = new HttpParams();
        params = params.append('userId', userId);
        return this.http.post(url, params);
    }

    async getUserRoleData() {
        try {
            const userId = this.storageService.decodeValue("UserId");
            if (!userId || userId === 'undefined') {
                throw new Error('UserId not found in storage');
            }
            const encryptedUserId = this.encryptDecryptService.encryptWithDefault(userId);
            const res = await firstValueFrom(this.getUserRoles(encryptedUserId));
            if (res?.roles?.length > 0) {
                this.storageService.setLocalCache('selectedRole', JSON.stringify(res.roles[0]));
                return res;
            } else {
                console.log('No roles found in response for getUserRoleData');
                throw { errorMessage: "No roles found in response" };
            }
        } catch (error) {
            console.log('Error fetching user roles for getUserRoleData:', error);
            throw { errorMessage: error };
        }
    }

    dataSecurity() {
        let url = `${Constants.KSA_APP_BASE_API_URL}/dataSecurity.do`;
        return this.http.post<any>(url, null);
    }

    saveClientFeedback(data: any) {
        let url = `${Constants.APP_BASE_API_URL}/saveClientFeedback`;
        return this.http.post<any>(url, data);
    }

    setKsaPermissions(KsaPermissions) {
        this.KsaPermissions = KsaPermissions;
    }

    emitsetKsaPermissions() {
        this.KsaPermissionsChangeEmitter.next(this.KsaPermissions);
    }

    getKsaPermissionsChangeObserve() {
        return this.KsaPermissionsChangeEmitter.asObservable();
    }

    // sendClickEvent() {
    //     this.subject.next({});
    // }
    // getClickEvent(): Observable<any> {
    //     return this.subject.asObservable();
    // }


    private subject1 = new Subject<any>();
    
    sendClickEventpost() {
        this.subject1.next({});
    }
    getClickEventpost(): Observable<any> {
        return this.subject1.asObservable();
    }

     initiateLifeCycleToSovos(responseIdList: string[], entityId: string, userId: string,direction: string): Observable<any> {
        const url = `${Constants.APP_BASE_API_URL}/initiateLifeCycleToSovos`;
        this.userEmail =
        this.authService?.instance?.getActiveAccount()?.username.toLowerCase().length > 0
            ? this.authService?.instance?.getActiveAccount()?.username.toLowerCase()
            : this.storageService.deCodeJWT('preferred_username');
        const httpOptions = {
            headers: new HttpHeaders({
              'Username': this.userEmail
              })
    };
        let reqs = new HttpParams();
        reqs = reqs.append('responseIdList', responseIdList.toString())
        reqs = reqs.append('entityId', entityId)
        reqs = reqs.append('userId', userId);
        reqs = reqs.append('direction', direction);
        
        return this.http.post<any>(url, reqs,httpOptions);
      }
}
